import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelectedResult } from "../../../contexts/SelectedResultContext";
import { buildSearchOfferDashboardPath } from "../../../Components/FlightBookingFlowMockup/flightBookingPathUtils";
import { buildLiveConfirmationViewModel } from "../bridge/liveStageModels";
import { useLiveFlightStage } from "../bridge/useLiveFlightStage";
import ConfirmationScreen from "./ConfirmationScreen";

/**
 * Thin live host. ConfirmationScreen is the preview component.
 * Reference comes only from persisted hold/order fields.
 */
export default function ConfirmationLive() {
  const navigate = useNavigate();
  const { booking, presentation } = useLiveFlightStage();
  const { dynamicOrder, ourSavedLDSOrder } = useSelectedResult();
  const orderRow = dynamicOrder || ourSavedLDSOrder || null;

  const confirmation = useMemo(
    () =>
      buildLiveConfirmationViewModel({
        holdResult: booking.holdResult,
        orderRow,
        passengers: booking.passengers,
        offer: presentation.offer,
        bookingStatus: booking.bookingStatus,
      }),
    [
      booking.holdResult,
      orderRow,
      booking.passengers,
      presentation.offer,
      booking.bookingStatus,
    ]
  );

  return (
    <ConfirmationScreen
      confirmation={confirmation}
      onAction={(actionId) => {
        if (actionId === "home") {
          navigate(buildSearchOfferDashboardPath({}));
          return;
        }
        if (actionId === "pay") {
          const hr = String(booking.holdResult?.hrBookingNumber || "")
            .trim()
            .toUpperCase();
          if (hr) {
            navigate(`/flight-orders/${encodeURIComponent(hr)}/payment`);
            return;
          }
          booking.goToStep("draftPayment");
        }
      }}
    />
  );
}
